import React from 'react';
import PropTypes from 'prop-types';
import NavigationComponents from '../component';

const FallbackElement = ({ children }) => <div>{children}</div>;
FallbackElement.propTypes = { children: PropTypes.node };

const getElementComponent = nodeName => NavigationComponents[nodeName] || FallbackElement;
const getElementStyles = (styles, id) => (styles && styles[id]) || {};

// The hack for avoid the key field MicroFrontend rerender issue.
// if element have stable unic key then it will not rerender after update structure.
let keyInc = 0;

const renderElements = ({
    key = 0,
    isPreview,
    structureType,
    structure: elements,
    styles,
}) => elements.reduce(
    (acc, { attributes = {}, children, nodeName, styleId }, index) => {
        // eslint-disable-next-line no-plusplus
        const id = isPreview ? keyInc++ : `${key}_${index}`;

        const Element = getElementComponent(nodeName);
        const hasChildren = Array.isArray(children) && children.length > 0;

        return [
            ...acc,
            <Element
                id={id}
                key={id}
                isPreview={isPreview}
                attributes={attributes}
                className={!key && !index && structureType}
                structureType={structureType}
                styles={getElementStyles(styles, styleId)}
            >
                {hasChildren
                        && renderElements({
                            key: id,
                            isPreview,
                            structureType,
                            structure: children,
                            styles,
                        })}
            </Element>,
        ];
    }, [],
);

export default renderElements;
